module.exports = __webpack_public_path__ + "4319494e5e072eb78bc23a6861fa9577.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1day.png
// module id = 874
// module chunks = 7